__turbopack_context__.v({
  "className": "noto_sans_bengali_21492c2-module__IucZxW__className",
});
